// @flow
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { animated } from 'react-spring/web.cjs';
import { SPACING } from '@tablekit/theme';
import { ImageCard, ErrorCard, TopRow, LinkButton, Text } from './static';

const baseStyles = css`
  position: absolute;
  top: 50%;
  left: 0;
`;

export const AnimatedImageCard = animated(styled(ImageCard)`
  ${baseStyles};
  padding: ${SPACING.L4};

  ${TopRow} {
    flex-direction: column;
    padding: 0;
  }
  ${LinkButton} {
    align-self: stretch;
    justify-content: center;
    margin: 0;
    padding: 0;
    & > span > span:last-of-type {
      display: none;
    }
    & > span > span:first-of-type {
      margin: 0;
    }
  }
  ${Text} {
    margin-left: 0;
    margin-top: ${SPACING.L4};
    text-align: center;
  }
`);

export const AnimatedErrorCard = animated(styled(ErrorCard)`
  ${baseStyles};
  padding: ${SPACING.L6};
`);

export const CARD_DISPLAYS = [
  {
    minWidth: 0,
    displayCount: 2,
    height: 224,
    gutter: parseInt(SPACING.L3, 10)
  },
  {
    minWidth: 576,
    displayCount: 3,
    height: 224,
    gutter: parseInt(SPACING.L4, 10)
  },
  {
    minWidth: 768,
    displayCount: 3,
    height: 264,
    gutter: parseInt(SPACING.L4, 10)
  },
  {
    minWidth: 1024,
    displayCount: 4,
    height: 264,
    gutter: parseInt(SPACING.L4, 10)
  },
  {
    minWidth: 1280,
    displayCount: 4,
    height: 240,
    gutter: parseInt(SPACING.L5, 10)
  },
  {
    minWidth: 1440,
    displayCount: 5,
    height: 264,
    gutter: parseInt(SPACING.L5, 10)
  }
];
